import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import styles from './collection.module.scss';
import CollectionEmpty from './CollectionEmpty';
import CollectionList from './CollectionList';

import { ReactComponent as IconClose } from '../../../../../assets/images/close.svg';
import { collectionProductsData } from '../../../../../store/collection';
import { bookingYear } from '../../../../../store/location';
import { loadersByName, popupByName, TARGET_ID_MODAL, togglePopup } from '../../../../../store/ui';
import Button, { ButtonKind } from '../../button/Button';
import Loading from '../../Loading';
import Portal from '../../Portal';

export const CollectionModal = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { opened } = useSelector(popupByName('collection'));
    const locationLoading = useSelector(loadersByName('location'));
    const collectionLoading = useSelector(loadersByName('collection'));
    const collectionProducts = useSelector(collectionProductsData);
    const bookingyear = useSelector(bookingYear);
    const isEmptyCollection = collectionProducts.length < 1;

    if (opened) {
        return (
            <Portal id={TARGET_ID_MODAL}>
                <div
                    className={styles.collectionModalWrapper}
                    onClick={() => dispatch(togglePopup({ name: 'collection', status: false }))}
                >
                    <div
                        className={classNames(styles.collectionModalInnerWrapper, 'collectionInnerWrapper', {
                            [styles.collectionModalEmptyInnerWrapper]: isEmptyCollection,
                        })}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <div className={styles.title}>
                            {isEmptyCollection ? (
                                <span />
                            ) : (
                                <div>
                                    <h3>
                                        {intl.formatMessage({ id: 'collection.title', defaultMessage: 'Ihre Auswahl' })}
                                        {' (' + `${collectionProducts.length}` + ')'}
                                    </h3>
                                    <h6>
                                        {intl.formatMessage({ id: 'collection.subtitle', defaultMessage: 'Preise' })}{' '}
                                        {bookingyear}
                                    </h6>
                                </div>
                            )}

                            <Button
                                kind={ButtonKind.LINK}
                                onClick={() => dispatch(togglePopup({ name: 'collection', status: false }))}
                            >
                                <IconClose width="20" height="20" />
                            </Button>
                        </div>

                        {locationLoading || collectionLoading ? (
                            <Loading relative />
                        ) : isEmptyCollection ? (
                            <CollectionEmpty isEmptyCollection={isEmptyCollection} />
                        ) : (
                            <CollectionList />
                        )}
                    </div>
                </div>
            </Portal>
        );
    }

    return null;
};
